// extracted by mini-css-extract-plugin
export default {"userDetailContainer":"UserDetail_userDetailContainer__XS8vL","userDetailHead":"UserDetail_userDetailHead__4fjTS"};